import React from "react";
export default function LogoText({data}){
    return <p className="faFont flex alignCenter gap5 logoText">
        {data.logo}
        {data.text}
    </p>
}